import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKyoceraComponent } from './simple-icons-kyocera.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKyoceraComponent ],
    exports:      [ SimpleIconsKyoceraComponent ],
    bootstrap:    []
})
export class SimpleIconsKyoceraModule {}
